import { Box, Button, Paper, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { http } from '../../api/http';
import { RichTextEditor } from '../../components/ui/RichTextEditor';

interface About {
  _id?: string;
  title: string;
  content: string;
}

export const AboutPage = () => {
  const [about, setAbout] = useState<About>({ title: '', content: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchAbout = async () => {
    const res = await http.get<{ success: boolean; data: About | null }>('/about');
    if (res.data.data) {
      setAbout(res.data.data);
    }
  };

  useEffect(() => {
    void fetchAbout();
  }, []);

  const handleSave = async () => {
    try {
      setSaving(true);
      setError(null);
      await http.put('/about', {
        title: about.title,
        content: about.content,
        isActive: true
      });
    } catch (err: any) {
      setError(err.response?.data?.message || 'Failed to save About content');
    } finally {
      setSaving(false);
    }
  };

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 3 }}>
        About Us
      </Typography>
      <Paper sx={{ p: 3 }}>
        <TextField
          margin="normal"
          fullWidth
          label="Title"
          value={about.title}
          onChange={(e) => setAbout({ ...about, title: e.target.value })}
        />
        <Typography variant="subtitle2" sx={{ mt: 2, mb: 0.5 }}>
          Content
        </Typography>
        <RichTextEditor
          value={about.content}
          onChange={(content) => setAbout({ ...about, content })}
          placeholder="Write your story…"
          minHeight={240}
        />
        {error && (
          <Typography color="error" sx={{ mt: 1 }}>
            {error}
          </Typography>
        )}
        <Button sx={{ mt: 2 }} onClick={handleSave} disabled={saving}>
          {saving ? 'Saving...' : 'Save'}
        </Button>
      </Paper>
    </Box>
  );
};

